import React, { FunctionComponent } from 'react';

import useTheme from '@gojob/ui-bits/styles/useTheme';

import CheeryTitle, { CheeryTitleProps } from '../../CheeryTitle';

export type TitleProps = {
  level?: CheeryTitleProps['as'];
  children?: string;
};

const useStyles = () => {
  const { spacing, breakpoint } = useTheme();

  return {
    root: {
      fontSize: spacing(6),
      lineHeight: spacing(8),
      textShadow: '0 2px 4px rgba(0,0,0,0.8)',
      marginBottom: spacing(2),
      [breakpoint.up('md')]: {
        fontSize: spacing(8),
        lineHeight: spacing(10),
        marginBottom: spacing(4),
      },
    },
    cherry: {
      left: spacing(-1),
      top: spacing(-1),
      height: spacing(4),
      width: spacing(4),
      [breakpoint.up('md')]: {
        height: spacing(8),
        width: spacing(8),
        left: spacing(-2),
        top: spacing(-3),
      },
    },
  } as const;
};

const Title: FunctionComponent<TitleProps> = (props) => {
  const { level, children } = props;
  const classes = useStyles();

  return (
    <CheeryTitle
      variant="headline1"
      as={level}
      color="white"
      css={classes.root}
      cherrySize={8}
      iconClassname={classes.cherry}
    >
      {children}
    </CheeryTitle>
  );
};

export default Title;
